module.exports = __webpack_public_path__ + "img/logo_kbbank@3x.8db2b5ae.png";